import React from "react";
import { Typography, Box } from "@bca/ui-library";
import FilterAsCheckbox from "./FilterAsCheckbox";
import prepareFiltersForApiCall from "./prepareFiltersForApiCall";

const GroupedCheckboxList = ({
  filterKey,
  categoryKey,
  filterValues,
  selectedCheckboxes,
  setAppliedCheckboxesCheckBoxGroup,
  parentFilterKey,
  additionalFilters,
  updateAdditionalFilters,
}) => {
  return (
    <Box key={filterKey}>
      <Typography fontSize={1} color="grey-blue" mt={5}>
        {filterKey}
      </Typography>
      {filterValues?.map(({ name, count }) => {
        return (
          <FilterAsCheckbox
            key={`${filterKey}-${name}`}
            id={name}
            label={name}
            resultsCount={count}
            isSelected={Boolean(
              selectedCheckboxes.find(
                (item) =>
                  item.filterKey === name && item.categoryKey === categoryKey
              )
            )}
            onChange={() => {
              const updatedAppliedCheckboxes =
                setAppliedCheckboxesCheckBoxGroup(
                  name,
                  categoryKey,
                  filterKey,
                  parentFilterKey
                );
              const apiCallFilters = prepareFiltersForApiCall(
                "bq",
                updatedAppliedCheckboxes,
                additionalFilters
              );
              updateAdditionalFilters({
                bq: apiCallFilters.searchParams.get("bq") || "",
              });
            }}
          />
        );
      })}
    </Box>
  );
};

export default GroupedCheckboxList;
